// Loader.jsx
import "./loader.css"
const Loader = () => (
  <div class="loader">
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="text"><span>TRACKWICKET</span></div>
  <div class="line"></div>
</div>
);

export default Loader;
